import { useEffect, useState } from "react";
import { Menu, X, Lock } from "lucide-react";
import { Link } from "react-router-dom";
import { useT } from "@/content/landing";
import { BrandLogo } from "@/components/BrandLogo";
import { LanguageSwitcher } from "./LanguageSwitcher";
import { scrollToId } from "./scroll";
export function Header() {
  const t = useT();
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener("scroll", onScroll, {
      passive: true
    });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);
  return <header className={`fixed inset-x-0 top-0 z-50 transition-all duration-300 ${scrolled ? "border-b border-[#E8ECF1] bg-white/85 backdrop-blur-md" : "border-b border-transparent"}`}>
      <div className="mx-auto flex h-16 max-w-6xl items-center justify-between px-4 sm:px-6">
        <a href="#top" onClick={e => {
        e.preventDefault();
        scrollToId("top");
      }} className="flex items-center gap-2.5 rounded-md focus-visible:ring-2 focus-visible:ring-[#3B82F6] focus-visible:ring-offset-2 focus-visible:outline-none">
          <BrandLogo className="h-11" />
        </a>

        <nav aria-label={t.ui.mainNav} className="hidden items-center gap-7 lg:flex">
          {t.nav.map(item => <a key={item.href} href={item.href} onClick={e => {
          e.preventDefault();
          scrollToId(item.href.slice(1));
        }} className="text-sm font-medium text-[#64748B] transition-colors hover:text-[#0F172A]">
              {item.label}
            </a>)}
          <LanguageSwitcher />
          <Link to="/login" className="inline-flex items-center gap-1.5 rounded-xl border border-[#E8ECF1] px-4 py-2.5 text-sm font-semibold text-[#475569] transition-colors hover:border-[#CBD5E1] hover:text-[#0F172A]">
            <Lock size={14} aria-hidden />
            {t.ui.corporateLogin}
          </Link>
          <Link to="/analyse" className="rounded-xl bg-[#3B82F6] px-5 py-2.5 text-sm font-semibold text-white shadow-sm shadow-blue-100 transition-colors hover:bg-[#2563EB]">
            {t.cta}
          </Link>
        </nav>

        <div className="flex items-center gap-2 lg:hidden">
          <LanguageSwitcher />
        <button type="button" aria-label={open ? t.ui.menuClose : t.ui.menuOpen} aria-expanded={open} onClick={() => setOpen(v => !v)} className="rounded-md p-2 text-[#0F172A] lg:hidden">
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
        </div>
      </div>

      {open && <div className="border-t border-[#E8ECF1] bg-white px-4 pt-3 pb-5 lg:hidden">
          <nav aria-label={t.ui.mobileNav} className="flex flex-col">
            {t.nav.map(item => <a key={item.href} href={item.href} onClick={e => {
          e.preventDefault();
          setOpen(false);
          scrollToId(item.href.slice(1));
        }} className="border-b border-[#E8ECF1] py-3 text-sm font-medium text-[#475569]">
                {item.label}
              </a>)}
            <Link to="/analyse" onClick={() => setOpen(false)} className="mt-4 rounded-xl bg-[#3B82F6] px-5 py-3 text-center text-sm font-semibold text-white">
              {t.cta}
            </Link>
            <Link to="/login" onClick={() => setOpen(false)} className="mt-3 inline-flex items-center justify-center gap-1.5 rounded-xl border border-[#E8ECF1] px-5 py-3 text-sm font-semibold text-[#475569]">
              <Lock size={14} aria-hidden />
              {t.ui.corporateLogin}
            </Link>
          </nav>
        </div>}
    </header>;
}